import { render, staticRenderFns } from "./pinjamanbarufrm.vue?vue&type=template&id=bf63f148&scoped=true&"
import script from "./pinjamanbarufrm.vue?vue&type=script&lang=js&"
export * from "./pinjamanbarufrm.vue?vue&type=script&lang=js&"
import style0 from "./pinjamanbarufrm.vue?vue&type=style&index=0&id=bf63f148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf63f148",
  null
  
)

export default component.exports